import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EmailSelectionTemplate from "@Broker/@HandlebarsTemplates/marketing/campaigns/_email-selection.hbs";
import Select2 from "@Shared/components/inputs/select2";
import { cloneDeep } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "MarketingEmailsSelect",
  components: {
    Select2
  },
  props: {
    multiple: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: null
    },
    value: {
      type: [Array, String, Object, Number],
      default: () => null
    },
    materialDesign: {
      type: Boolean,
      default: true
    },
    spaceClasses: {
      type: String,
      default: "col-12 mt-3 pb-4 px-0"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    emails: {
      type: Array,
      default: () => []
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    selectOptions: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      initSelect: false
    };
  },
  computed: {
    options() {
      if (!this.initSelect) return;
      const formatResult = state => $(EmailSelectionTemplate(_objectSpread(_objectSpread({}, state), {}, {
        verifiedText: this.$t("global.words.verified")
      })));
      return _objectSpread({
        templateResult: formatResult,
        allowClear: false,
        closeOnSelect: !this.multiple,
        placeholder: this.$t("campaigns.actions.searchAnEmail"),
        dropdownCssClass: "emails-vue-select",
        escapeMarkup(markup) {
          return markup;
        }
      }, this.selectOptions);
    },
    formGroupClass() {
      if (this.materialDesign) return "form-group-material";
      return "form-group";
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initSelect = true;
      this.$refs.select.initSelect2();
    });
  },
  methods: {
    handleChange(data, type) {
      this.$emit("change", data, type);
    },
    reset() {
      this.$refs.select.setValue("");
    },
    formatData(data) {
      var _data$map, _data;
      data = cloneDeep(data);
      return (_data$map = (_data = data) == null ? void 0 : _mapInstanceProperty(_data).call(_data, ref => {
        ref.id = ref.emailId;
        ref.text = ref.email;
        return ref;
      })) != null ? _data$map : [];
    }
  }
});